/**
 * Assets factory.
 * Factory class for creation of Sprites, Text etc.
 */
class Assets
{

    constructor()
    {
        this.app = PIXI.app;
        this.resources = PIXI.loader.resources;

        this.dynamicLoader = new PIXI.loaders.Loader();
        this.dynamicAssets = [];
    }



    /**
     * Return a texture with specified id. The id is based on the file name of the image file.
     * The texture atlases are searched consecutively until the image is found
     * The file suffix (.png) is added automatically;
     * Returns null if texture is not found
     * @public
     * @param textureId {String}
     * @param extension {String}
     * @return {PIXI.Texture}
     */
    getTexture(textureId, extension = '.png') {
        textureId += extension;
        let texture = null;
        for (let atlasName in this.resources) {
            let atlas = this.resources[atlasName];

            // make this check because dynamic assets are added in the end and .mp3 files does not have .textures
            if (!atlas.textures) {
                continue;
            }
            texture = atlas.textures[textureId];
            if (texture != undefined) {
                break;
            }
        }
        if (texture == null) {
            let res = this.dynamicLoader.resources;
            for (let atlasName in res) {
                let atlas = res[atlasName];

                // make this check because dynamic assets are added in the end and .mp3 files does not have .textures
                if (!atlas.textures) {
                    continue;
                }
                texture = atlas.textures[textureId];
                if (texture != undefined) {
                    break;
                }
            }
        }

        if (texture == null) {
            console.log('Could not find texture : ' + textureId);
        }
        // else
        // {
        //     texture.mipmap = true;
        // }

        return texture;
    }


    /**
     * Get a Sprite which uses texture with a specified id
     * @public
     * @param textureId {String}
     * @returns {PIXI.Sprite}
     */
    getSprite(textureId, extension = '.png')
    {
        return new PIXI.Sprite(this.getTexture(textureId, extension));
    }


    /**
     * Factory method for creating text fields.
     * @public
     * @param text {String} - the text to be displayed
     * @param size {Number}
     * @param font {String}
     * @param color {String}
     * @param lineHeight {Number} - distance between lines
     * @param wrapWidth {Number} - text wrap width
     * @param additionalStyle {Object} - additional style variables
     * @returns {PIXI.Text}
     */
    getTF(text, size, font=null, color=null, lineHeight=null, wrapWidth=null, additionalStyle=null)
    {
        font = font == null ? 'Khand' : font;
        color = color == null ? '#ffffff' : color;
        size = Math.round(size);

        let styleVars = {fontFamily: font, fontSize: size, fill: color, align: 'center'};

        for (let stylePropName in additionalStyle)
        {
            styleVars[stylePropName] = additionalStyle[stylePropName];
        }

        if (lineHeight != null)
        {
            styleVars.lineHeight = Math.round(size * lineHeight);
        }

        if (wrapWidth != null)
        {
            styleVars.wordWrap = true;
            styleVars.wordWrapWidth = wrapWidth;
        }

        const defTextStyle = new PIXI.TextStyle(styleVars);

        const tf = new PIXI.Text(text, defTextStyle);

        return tf;
    }



    /**
     * Generates an array of textures.
     * @public
     * @param prefix {Number} texture prefix
     * @param padLen {Number} number of symbols of padding of the numeric part (e.g. 001)
     * @param startNum {Number} the id of the first texture
     * @param endNum {Number} the id of the last texture
     * @return {Array} Array of PIXI.Texture
     */
    generateFrames(prefix, padLen, startNum, endNum)
    {
        let frames = [];
        for (let frameIdx = startNum; frameIdx <= endNum; frameIdx++)
        {
            let frameString = String(frameIdx);
            while (frameString.length < padLen)
            {
                frameString = '0' + frameString;
            }
            let texture = this.getTexture(prefix + frameString);
            frames.push(texture);
        }

        return frames;
    }


    getLoadedJSONData(jsonName)
    {
        let data = this.resources[jsonName].data;
        return data;
    }


    getDragonBoneAtlasTexture(atlasName)
    {
        let texture = this.resources[atlasName].texture;
        return texture;
    }


    /**
     * Loads assets dynamically
     * @public
     * @param assets {Array} array of all assets to be loaded
     * @param callback {Function} function that is called after assets are loaded
     */
    addDynamic(assets, callback)
    {
        this._completeCallback = callback;

        for (let i=0; i<assets.length; i++)
        {
            this.dynamicLoader.add(assets[i].name, "assets/" + assets[i].file);
            this.dynamicAssets.push(assets[i].name);
            console.log("[Assets] Adding dynamic texture: " + assets[i].name + " - " + assets[i].file);
        }

        this.dynamicLoader.load(this.onDynamicAssetsLoaded.bind(this));
    }


    /**
     * Calls the callback function when dynamic assets are loaded
     * @private
     */
    onDynamicAssetsLoaded()
    {
        console.log("[Assets] Dynamic assets loaded");
        this._completeCallback();
    }

    /**
     * Removes all loaded dynamic assets
     * @public
     */
    removeDynamic()
    {
        let res = this.dynamicLoader.resources;

        for (let i = 0; i < this.dynamicAssets.length; i++)
        {
            let textures = res[this.dynamicAssets[i]].textures;

            for (let key in textures)
            {
                let t = textures[key];
                if (t)
                {
                    // console.log("[Assets] Removing dynamic asset: " + key);
                    t.destroy(true);
                }
            }
        }
        // resets the loader
        this.dynamicLoader.reset();
        this.dynamicAssets = [];
    }
}

export default Assets;